import SchoolSelector from './SchoolSelector';

export { SchoolSelector };
